import React from "react";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { Button, Icon as AibleIcon } from "aible";

import { createUserInfoQuery } from "containers/Login/reducer";

import SearchInput from "components/Inputs/SearchInput/SearchInput";

import errorIcon from "images/tileIcons/error.svg";

import calendarIcon from "images/tileIcons/calendar.svg";
import linkIcon from "images/tileIcons/link.svg";
import targetIcon from "images/tileIcons/target.svg";
import typeIcon from "images/tileIcons/type.svg";
import userIcon from "images/tileIcons/user.svg";
import warningIcon from "images/tileIcons/warning.svg";
import trashIcon from "images/trash-alt-light.svg";
import columnsIcon from "images/tileIcons/columns.svg";

import styles from "./utils.module.css";
import tileStyles from "components/Tiles/style.module.css";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

export { default as getStyles } from "components/Home/Utils/getStyles";
import getStyles from "components/Home/Utils/getStyles";

export function getTileDimensions() {
  const wrapperPadding = parseInt(tileStyles.wrapperPadding);
  const dimensions = {
    height: parseInt(tileStyles.tileHeight),
    width: parseInt(tileStyles.tileWidth)
  };
  dimensions.wrapperHeight = dimensions.height + 2 * wrapperPadding;
  dimensions.wrapperWidth = dimensions.width + 2 * wrapperPadding;
  return dimensions;
}

export function getPrettyNumber(num) {
  let numSign = num < 0 ? "-" : "";
  let absNum = Math.abs(num);
  if (absNum >= 1000) {
    absNum = Math.round(absNum);
    const exponents = ["", "k", "m", "b", "t"];
    const exponentIndex = Math.floor((("" + absNum).length - 1) / 3);
    let significantNum = Math.round((absNum / Math.pow(1000, exponentIndex)) * 10) / 10;
    // if (parseFloat(significantNum) % 1 === 0) {
    //   significantNum = Math.round(parseFloat(significantNum));
    // }
    return numSign + significantNum + exponents[exponentIndex];
  } else {
    return numSign + Math.round(absNum * 10) / 10;
  }
}

export class FlexSpacer extends React.PureComponent {
  render() {
    return <div style={{ flexGrow: 1 }}></div>;
  }
}

export class Divider extends React.PureComponent {
  render() {
    const { margin, width } = this.props;
    return (
      <div className={styles.divider} style={{ margin: margin || "0px" }}>
        <div className={styles.dividerLine} style={{ width: width || "80%" }}></div>
      </div>
    );
  }
}

export class TypeIcon extends React.PureComponent {
  render() {
    const { type, border, round, size, num, background, padding, responsive, hideMobile, isMenu } = this.props;
    const icon = getStyles(type);
    if (icon) {
      const iconStyle = {};
      if (border) {
        iconStyle.border = "1px solid";
        if (isMenu) {
          iconStyle.borderColor = "#7E69D7";
        }
      }
      iconStyle.borderRadius = round ? "50%" : "3px";
      if (size) {
        iconStyle.width = size;
        iconStyle.height = size;
      }
      if (background) {
        iconStyle.background = background;
      }
      if (responsive) {
        iconStyle.width = "100%";
        iconStyle.height = "auto";
        iconStyle.maxHeight = "100%";
      }
      return (
        <div
          className={styles.typeIconWrapper + (hideMobile ? " " + styles.hideMobile : "")}
          style={padding ? { padding: padding } : {}}
        >
          {num !== undefined && <p className={icon.text}>{num}</p>}
          <div className={styles.icon + " " + icon.icon} style={iconStyle}>
            <img src={icon.image} alt={type} />
          </div>
        </div>
      );
    } else return false;
  }
}

export class InfoIcon extends React.PureComponent {
  render() {
    const { size, padding, icon, type } = this.props;
    const style = {};
    if (size) {
      style.height = size;
      style.width = size;
    }
    if (padding) {
      style.padding = padding;
    }
    let image;
    switch (type) {
      case "calendar":
        image = calendarIcon;
        break;
      case "link":
        image = linkIcon;
        break;
      case "target":
        image = targetIcon;
        break;
      case "type":
        image = typeIcon;
        break;
      case "user":
        image = userIcon;
        break;
      case "warning":
        image = warningIcon;
        break;
      case "columns":
        image = columnsIcon;
        break;
    }
    if (icon) {
      image = icon;
    }
    return (
      <div className={styles.infoIcon} style={style}>
        <img src={image} alt={type} />
      </div>
    );
  }
}

export class InfoItem extends React.PureComponent {
  render() {
    const { className, style, icon, iconClass, iconStyle, text, noIcon, isLink, hideMobile } = this.props;
    return (
      <div
        className={styles.infoItem + (className ? " " + className : "") + (hideMobile ? " " + styles.hideMobile : "")}
        style={style || {}}
      >
        {noIcon || !icon ? (
          ""
        ) : (
          <div className={styles.infoIcon + (iconClass ? " " + iconClass : "")} style={iconStyle || {}}>
            {icon}
          </div>
        )}
        {isLink ? (
          <a>{text || <React.Fragment>&nbsp;</React.Fragment>}</a>
        ) : (
          text || <React.Fragment>&nbsp;</React.Fragment>
        )}
      </div>
    );
  }
}

export class TileAction extends React.PureComponent {
  render() {
    const { icon, text, subText } = this.props;
    return (
      <div className={styles.tileActionWrapper}>
        <div className={styles.tileActionIcon}>{icon}</div>
        <div className={styles.tileActionText}>
          {text}
          {subText}
        </div>
      </div>
    );
  }
}

export class Icon extends React.PureComponent {
  render() {
    const { src, style, color } = this.props;
    const iconStyle = { ...style };
    if (color) {
      iconStyle.background = color;
    }
    return (
      <div className={styles.iconWrapper} style={iconStyle}>
        <img src={src} />
      </div>
    );
  }
}

export class NumberDisplay extends React.PureComponent {
  render() {
    const { number, label, hoverClass, colorClass, image, isWide, isThin, hideMobile } = this.props;
    const isNegative = number < 0;
    const prettyNumber = getPrettyNumber(Math.abs(number || 0));
    let fontSize;
    switch (prettyNumber.length) {
      case 0:
      case 1:
        fontSize = "42px";
        break;
      case 2:
        fontSize = "36px";
        break;
      case 3:
        fontSize = "30px";
        break;
      case 4:
        fontSize = "24px";
        break;
      case 5:
        fontSize = "20px";
        break;
      default:
        fontSize = "18px";
    }
    return (
      <div
        className={
          styles.popTrigger +
          (isWide ? " " + styles.popTriggerWide : "") +
          (isThin ? " " + styles.popTriggerThin : "") +
          (hideMobile ? " " + styles.hideMobile : "") +
          (hoverClass ? " " + hoverClass : " " + styles.popTriggerNoHover)
        }
      >
        {number !== undefined && !image ? (
          <h1 className={colorClass ? colorClass : ""} style={{ fontSize }}>
            {(isNegative ? "-" : "") + prettyNumber}
          </h1>
        ) : (
          ""
        )}
        {image ? <img src={image} /> : ""}
        <p className={colorClass ? colorClass : ""}>{label}</p>
      </div>
    );
  }
}

export class ErrorOverlay extends React.PureComponent {
  render() {
    const { errors, warnings, annotations, popClass, popRowClass, retryHandler, retryLabel, isDataMode } = this.props;
    let popTitle = "";
    let popText = "";
    if (annotations && annotations.length > 0) {
      popText = annotations.length + " Annotation" + (annotations.length === 1 ? "" : "s");
    }
    if (errors && errors.length > 0) {
      popTitle = errors.length + " Error" + (errors.length === 1 ? "" : "s");
      if (isDataMode) {
        popText = "We found issues with your dataset";
      } else {
        popText = "We found " + errors.length + " error" + (errors.length === 1 ? "" : "s");
      }
    }
    return (
      <div className={styles.errorOverlayWrapper}>
        <div className={styles.errorOverlay}>
          {isDataMode ? (
            <React.Fragment>
              <AibleIcon type={"toolsPurple"} size={36} />
              <a
                className={styles.errorTrigger + " " + styles.errorCTA}
                onClick={(e) => {
                  e.stopPropagation();
                  window.open("https://enaible.aible.com/aible-data-ask-an-expert" + createUserInfoQuery(), "_blank");
                }}
              >
                {"We found issues with your dataset. Click here to have one of our experts help you out."}
              </a>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className={styles.errorIcon}>
                <img src={errorIcon} alt={"error"} />
              </div>
              <h1>Error</h1>
              {popText ? (
                <OverlayTrigger
                  placement="top"
                  trigger={["click"]}
                  rootClose
                  overlay={
                    <Popover id="popover-positioned-top" title={popTitle}>
                      <div className={popClass}>
                        {(errors || []).map((field, index) => (
                          <div key={field.message} className={popRowClass}>
                            {field.message}
                          </div>
                        ))}
                        {annotations ? (
                          <div className={styles.popTitle}>
                            {"Annotation" + (annotations.length === 1 ? "" : "s") + ":"}
                          </div>
                        ) : (
                          ""
                        )}
                        {(annotations || []).map((field, index) => (
                          <div key={field.message} className={popRowClass}>
                            {field.message}
                          </div>
                        ))}
                      </div>
                    </Popover>
                  }
                >
                  <a onClick={(e) => e.stopPropagation()} className={styles.errorTrigger}>
                    {popText}
                  </a>
                </OverlayTrigger>
              ) : (
                ""
              )}
            </React.Fragment>
          )}
          {retryHandler ? (
            <a className={styles.errorRetry} onClick={retryHandler}>
              {retryLabel ? retryLabel : "Retry"}
            </a>
          ) : (
            false
          )}
        </div>
      </div>
    );
  }
}

export class DeleteButton extends React.PureComponent {
  render() {
    const { clickHandler, className, type, action, icon } = this.props;
    const label = (action ? action : "delete") + (type ? " " + type : "");
    return (
      <div className={className ? className : ""}>
        <OverlayTrigger
          placement="top"
          trigger={["hover"]}
          rootClose
          overlay={
            <Popover id="popover-positioned-top">
              <div className={styles.deleteButtonTip}>{label}</div>
            </Popover>
          }
        >
          <Button type="secondary" className={styles.deleteButton} onClick={clickHandler}>
            <img className={styles.deleteButtonIcon} src={trashIcon} />
          </Button>
        </OverlayTrigger>
      </div>
    );
  }
}

export class DeleteButtonMedium extends React.PureComponent {
  render() {
    const { clickHandler, className, type, action, icon } = this.props;
    const label = (action ? action : "delete") + (type ? " " + type : "");
    return (
      <div className={className ? className : ""}>
        <OverlayTrigger
          placement="top"
          trigger={["hover"]}
          rootClose
          overlay={
            <Popover id="popover-positioned-top">
              <div className={styles.deleteButtonTip}>{label}</div>
            </Popover>
          }
        >
          <Button type="secondary" className={styles.deleteButtonMedium} onClick={clickHandler}>
            <img className={styles.deleteButtonIcon} src={trashIcon} />
          </Button>
        </OverlayTrigger>
      </div>
    );
  }
}

export class Menu extends React.PureComponent {
  createSearchHander() {
    const { search, searchHandler } = this.props;
    let inputTimer;
    return (value) => {
      clearTimeout(inputTimer);
      inputTimer = setTimeout(() => {
        searchHandler;
      }, 1500);
    };
  }
  render() {
    const { selected, selectHandler, search, searchHandler, options, isLoading } = this.props;

    return (
      <div className={styles.menuWrapper}>
        <div className={styles.menu}>
          {options ? (
            <div className={styles.menuTabs}>
              {options.map((option, i) => {
                if (!option) return "";
                const value = option.value !== undefined ? option.value : option.text;
                return (
                  <MenuTab
                    {...option}
                    isLoading={isLoading && isLoading[value] === true}
                    key={value}
                    value={value}
                    selected={value === selected}
                    onClick={selectHandler ? () => selectHandler(value) : undefined}
                  />
                );
              })}
            </div>
          ) : (
            ""
          )}
          <div className={styles.menuExpansion}>
            {searchHandler ? <SearchInput value={search} onChange={(value) => searchHandler(value)} /> : ""}
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

class MenuTab extends React.PureComponent {
  render() {
    const { value, text, icon, isLoading, selected, onClick } = this.props;

    return (
      <div className={styles.menuTabWrapper}>
        <div
          id={"menuTab_" + value}
          className={(onClick ? styles.menuTab : styles.menuTabNoHover) + (selected ? " " + styles.selected : "")}
          onClick={onClick}
        >
          {icon === undefined && value !== "all" ? (
            isLoading ? (
              <LoadingIndicator style={{ width: "35px", transform: "scale(0.30)", margin: "0px" }} />
            ) : (
              <TypeIcon type={value} size={"20px"} padding={"0px"} border={selected} round isMenu />
            )
          ) : (
            ""
          )}
          <p className={icon === undefined && value !== "all" ? styles.hideMobile : ""}>{text}</p>
        </div>
      </div>
    );
  }
}

export class TopMenu extends React.PureComponent {
  createSearchHander() {
    const { search, searchHandler } = this.props;
    let inputTimer;
    return (value) => {
      clearTimeout(inputTimer);
      inputTimer = setTimeout(() => {
        searchHandler;
      }, 1500);
    };
  }
  render() {
    const { selected, selectHandler, search, searchHandler, options, isLoading } = this.props;

    return (
      <div className={styles.topMenuWrapper}>
        <div className={styles.topMenu}>
          {options ? (
            <div className={styles.topMenuTabs}>
              {options.map((option, i) => {
                if (!option) return "";
                const value = option.value !== undefined ? option.value : option.text;
                return (
                  <TopMenuTab
                    {...option}
                    isLoading={isLoading && isLoading[value] === true}
                    key={value}
                    value={value}
                    selected={value === selected}
                    onClick={selectHandler ? () => selectHandler(value) : undefined}
                  />
                );
              })}
            </div>
          ) : (
            ""
          )}
          <div className={styles.topMenuExpansion}>
            {searchHandler ? (
              <SearchInput
                value={search}
                onChange={(value) => searchHandler(value)}
                inputClass={styles.topMenuSearch}
                iconClass={styles.topMenuSearchClose}
              />
            ) : (
              ""
            )}
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

class TopMenuTab extends React.PureComponent {
  render() {
    const { value, text, icon, isLoading, selected, onClick } = this.props;

    return (
      <div
        id={"menuTab_" + value}
        className={(onClick ? styles.topMenuTab : styles.topMenuTabNoHover) + (selected ? " " + styles.selected : "")}
        onClick={onClick}
      >
        {icon === undefined && value !== "all" ? (
          isLoading ? (
            <LoadingIndicator style={{ width: "35px", transform: "scale(0.30)", margin: "0px" }} />
          ) : (
            <TypeIcon type={value} size={"24px"} isMenu background={"transparent"} padding={"0px 5px 0px 0px"} />
          )
        ) : (
          ""
        )}
        <p className={icon === undefined && value !== "all" ? styles.hideMobile : ""}>{text}</p>
      </div>
    );
  }
}
